import { FC } from "react"

import { Toggle } from "./Toggle"

interface ToggleCardProps {
  label: string
  checked: boolean
  onChange: () => void
  disabled?: boolean
}

export const ToggleCard: FC<ToggleCardProps> = ({ label, checked, onChange, disabled }) => (
  <div className="flex items-center justify-between gap-4 max-w-md px-4 py-3 border rounded-lg border-black/10 dark:border-white/10 bg-white dark:bg-[#0C0C1A]">
    <span className="text-base font-medium text-gray-800 dark:text-white">{label}</span>
    <Toggle checked={checked} onChange={onChange} disabled={disabled} />
  </div>
)
